<template>
  <div class="expertsrecommend">
    <mt-header title="专家推荐">
      <mt-button slot="left" icon="back" @click.native="$router.go(-1)"></mt-button>
    </mt-header>
    <!-- 专家 -->
    <div class="expertbox">
        <h1>这里都是行业内可信赖的专家</h1>
        <h6>每个专家都经过人工严格审核</h6>
        <div class="expertlist">
            <div class="listitem" >
                <img :src="httpurl+datalistone.photo" alt="">
                <p class="name">
                    {{nickname}}/{{datalistone.position}}
                </p>
                <p class="info" style="-webkit-box-orient: vertical;">{{datalistone.aboutMe}}</p>
                <div class="classifybox">
                    <p class="classify" v-for="(item,index) in dataoneskills" :key="index">{{item}}</p>
                </div>
            </div>
            <div class="listitem" >
                <img :src="httpurl+datalisttwo.photo" alt="">
                <p class="name">
                    {{nicknametwo}}/{{datalisttwo.position}}
                </p>
                <p class="info" style="-webkit-box-orient: vertical;">{{datalisttwo.aboutMe}}</p>
                <div class="classifybox">
                    <p class="classify" v-for="(item,index) in datatwoskills" :key="index">{{item}}</p>
                </div>
            </div>
           <div class="listitem" >
                <img :src="httpurl+datalistthree.photo" alt="">
                <p class="name">
                    {{nicknamethree}}/{{datalistthree.position}}
                </p>
                <p class="info" style="-webkit-box-orient: vertical;">{{datalistthree.aboutMe}}</p>
                <div class="classifybox">
                    <p class="classify" v-for="(item,index) in datathreeskills" :key="index">{{item}}</p>
                </div>
            </div>
            <div class="listitem" >
                <img :src="httpurl+datalistfour.photo" alt="">
                <p class="name">
                    {{nicknamefour}}/{{datalistfour.position}}
                </p>
                <p class="info" style="-webkit-box-orient: vertical;">{{datalistfour.aboutMe}}</p>
                <div class="classifybox">
                    <p class="classify" v-for="(item,index) in datafourskills" :key="index">{{item}}</p>
                </div>
            </div>
            <div class="listitem" >
                <img :src="httpurl+datalistfive.photo" alt="">
                <p class="name">
                    {{nicknamefive}}/{{datalistfive.position}}
                </p>
                <p class="info" style="-webkit-box-orient: vertical;">{{datalistfive.aboutMe}}</p>
                <div class="classifybox">
                    <p class="classify" v-for="(item,index) in datafiveskills" :key="index">{{item}}</p>
                </div>
            </div>
            <div class="listitem" >
                <img :src="httpurl+datalistsix.photo" alt="">
                <p class="name">
                    {{nicknamesix}}/{{datalistsix.position}}
                </p>
                <p class="info" style="-webkit-box-orient: vertical;">{{datalistsix.aboutMe}}</p>
                <div class="classifybox">
                    <p class="classify" v-for="(item,index) in datasixskills" :key="index">{{item}}</p>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'expertsrecommend',
  data () {
    return {
        datalistone:'',
        nickname:'',
        dataoneskills:[],
        datalisttwo:'',
        nicknametwo:'',
        datatwoskills:[],
        datalistthree:'',
        nicknamethree:'',
        datathreeskills:[],
        datalistfour:'',
        nicknamefour:'',
        datafourskills:[],
        datalistfive:'',
        nicknamefive:'',
        datafiveskills:[],
        datalistsix:'',
        nicknamesix:'',
        datasixskills:[],
        httpurl:'http://oss.yunzhitu.com/',
    }
  },
  created(){
    this.datalist()
    this.getimgurl()
    // this.changeData();
  },
  methods: {
    getimgurl:function(){
      let _this=this
      this.axios.get('url/user/imgHttpUrl.json')
      .then(function (res) {
        // _this.httpurl=res.data
      })
    },
    datalist:function(){
      let _this = this
      this.axios.get('url/account/userInfo/getUserInformationById?id=3506')
      .then(function (res) {
        _this.datalistone=res.data
        _this.nickname=res.data.account.name
        _this.dataoneskills=res.data.skills.split('@')
      })
      this.axios.get('url/account/userInfo/getUserInformationById?id=2230')
      .then(function (res) {
        _this.datalisttwo=res.data
        _this.nicknametwo=res.data.account.name
        _this.datatwoskills=res.data.skills.split('@')
      })
      this.axios.get('url/account/userInfo/getUserInformationById?id=2581')
      .then(function (res) {
        _this.datalistthree=res.data
        _this.nicknamethree=res.data.account.name
        _this.datathreeskills=res.data.skills.split('@')
      })
      this.axios.get('url/account/userInfo/getUserInformationById?id=8302')
      .then(function (res) {
        _this.datalistfour=res.data
        _this.nicknamefour=res.data.account.name
        _this.datafourskills=res.data.skills.split('@')
      })
      this.axios.get('url/account/userInfo/getUserInformationById?id=8482')
      .then(function (res) {
        _this.datalistfive=res.data
        _this.nicknamefive=res.data.account.name
        _this.datafiveskills=res.data.skills.split('@')
      })
      this.axios.get('url/account/userInfo/getUserInformationById?id=5226')
      .then(function (res) {
        _this.datalistsix=res.data
        _this.nicknamesix=res.data.account.name
        _this.datasixskills=res.data.skills.split('@')
      })
    }
  }
}
</script>

<style scoped>
.expertsrecommend{
    background:#f5f5f5;
}
.expertbox{
    text-align:center;
    margin-bottom:70px;
    padding:0 10px;
}
.expertbox h1{
    color:#1878fd;
    font-weight: bold;
    font-size:22px;
    padding-top:30px;
}
.expertbox h6{
    padding-top:12px;
    color:#333;
    margin-bottom:20px;
}
.expertbox .expertlist{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.expertlist .listitem{
    width: 45%;
    margin-top: 10px;
    background: #fff;
    border-radius: 10px;
    padding: 0 6px;
}
.expertlist .listitem img{
    width: 110px;
    height: 110px;
    border-radius: 50%;
    text-align: center;
    margin: 17px 0;
}
.expertlist .listitem .name{
    width:100%;
    color:#1878fd;
    font-weight:bold;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    text-align: left;
}
.listitem .info{
    color:#333;
    font-size:14px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    width:100%;
    height:38px;
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: left;
}
.expertlist .listitem .classifybox{
    /* padding-bottom:20px; */
    overflow: hidden;
    max-height:22px;
    /* width:100%;
    white-space: nowrap; */
    /* text-overflow:ellipsis; */
    margin-bottom:12px;
    text-align:left;
}
.expertlist .listitem .classifybox .classify{
    display:inline-block;
    font-size: 12px;
    color: #4d8efd;
    background-color: #fff;
    border:1px solid #1878fd;
    padding: 0 5px;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    margin-right:3px;
    height: 18px;
    line-height: 18px;
}
</style>



// WEBPACK FOOTER //
// expertsrecommend.vue?07f79bf8